// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2kyhP","sendOtp":"AuthorizeToLogin_sendOtp__1x7XE"};